
export default {
    inject: ['baseUrl', 'tidalUrl', 'hasNavigationListener'],
    inheritAttrs: false,
    props: {
        href: {
            type: String,
            default: null,
        },
        isNuxt: {
            type: Boolean,
            default: false,
        },
        external: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {boolean} */
        useNuxt() {
            // @ts-ignore
            return this._isNuxt && !this.hasNavigationListener;
        },
        /** @return {boolean} */
        _isNuxt() {
            return this.isNuxt && !this.external;
        },
        /** @return {string | null} */
        _href() {
            if (this.disabled) {
                return null;
            }

            const href = this.href && this.href !== '/' ? this.href : '';
            if (this.external) {
                return href;
            }

            const baseUrl = this.baseUrl || '/';

            if (this.isNuxt) {
                return baseUrl + (baseUrl.endsWith('/') && href.startsWith('/') ? href.slice(1) : href);
            }

            // @ts-ignore
            const tidalUrl = /** @type {string?} */(this.tidalUrl);
            return (tidalUrl || baseUrl) + href;
        },
    },
    methods: {
        /** @param {MouseEvent} event */
        clickEmitter(event) {
            // @ts-ignore
            const hasNavigationListener = /** @type {boolean} */(this.hasNavigationListener);
            if (!hasNavigationListener || this.disabled) {
                return;
            }

            event.preventDefault();
            this.$emit('click', { url: this.href, isNuxt: this._isNuxt });
        },
    },
};
